var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],ref:"dashboard",staticClass:"vcp-dashboard",attrs:{"autoplay":""}},[_c('Progress'),_c('Controls',{attrs:{"muted":_vm.muted}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }